/* eslint-disable react/require-default-props */

import {
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  RadioGroup,
  Radio,
  HStack,
  VStack,
  Text,
} from '@chakra-ui/react';

function RadioGroupField({
  label,
  name,
  value,
  errorMessage,
  helperText,
  options = [],
  id,
  onChange,
  orientation = 'horizontal',
  spacing = 6,
  disabled,
  required,
  ...customProps
}) {
  return (
    <FormControl {...customProps} isInvalid={errorMessage}>
      {label && (
        <FormLabel display="flex" htmlFor={id || label} fontSize="14px">
          {label}{' '}
          {required && (
            <Text color="red.500" ml={1} fontWeight="600">
              *
            </Text>
          )}
        </FormLabel>
      )}
      <RadioGroup
        id={id || label}
        name={name}
        value={value}
        onChange={onChange}
        isDisabled={disabled}
      >
        {orientation === 'horizontal' ? (
          <HStack spacing={spacing} w="100%" flexWrap="wrap">
            {options.map((option) => (
              <Radio key={option.value} value={option.value}>
                {option.label}
              </Radio>
            ))}
          </HStack>
        ) : (
          <VStack spacing={spacing} align="start">
            {options.map((option) => (
              <Radio key={option.value} value={option.value}>
                {option.label}
              </Radio>
            ))}
          </VStack>
        )}
      </RadioGroup>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
      <FormErrorMessage>{errorMessage}</FormErrorMessage>
    </FormControl>
  );
}

export { RadioGroupField };
